<template>
  <div style="display: flex;
  flex-direction: column;
  align-items: start;">
    <h2>Distancia entre dos puntos marcados</h2>

    <button
    style="background-color: blue;
    padding: 1rem;
    color: white;"
     @click="marcarPrimeraUbicacion">Marcar primera ubicación</button>
    <p v-if="pos1">Primera ubicación: {{ pos1.latitude.toFixed(5) }}, {{ pos1.longitude.toFixed(5) }}</p>

    <button
    style="background-color: red;
    padding: 1rem;
    color: white;"
     @click="marcarSegundaUbicacion" :disabled="!pos1">Marcar segunda ubicación</button>
    <p v-if="pos2">Segunda ubicación: {{ pos2.latitude.toFixed(5) }}, {{ pos2.longitude.toFixed(5) }}</p>

    <button
    style="background-color: yellowgreen;
    padding: 1rem;
    color: white;"
    @click="calcularDistancia" :disabled="!pos1 || !pos2">Calcular distancia</button>

    <p v-if="distancia !== null">Distancia: {{ distancia.toFixed(2) }} metros</p>

    <h2>Device Info</h2>
    <p v-if="deviceId">🆔 Device ID: <strong>{{ deviceId }}</strong></p>
    <p v-if="error" style="color: red;">❌ Error: {{ error }}</p>
    <button @click="getDeviceId">Obtener Device ID</button>

  </div>
</template>

<script setup>
import { Geolocation } from '@capacitor/geolocation'
import { ref } from 'vue'

const pos1 = ref(null)      // Primera ubicación marcada
const pos2 = ref(null)      // Segunda ubicación marcada
const distancia = ref(null) // Distancia calculada

function deg2rad(deg) {
  return deg * (Math.PI / 180)
}

function haversine(lat1, lon1, lat2, lon2) {
  const R = 6371000 // Radio Tierra en metros
  const dLat = deg2rad(lat2 - lat1)
  const dLon = deg2rad(lon2 - lon1)

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return R * c
}

async function marcarPrimeraUbicacion() {
  try {

    window.alert( 'iniciando' )
    const pos = await Geolocation.getCurrentPosition()
    pos1.value = {
      latitude: pos.coords.latitude,
      longitude: pos.coords.longitude
    }
    distancia.value = null // reseteamos distancia si había una previa
  } catch (error) {
    window.alert( error )
    console.error('Error obteniendo primera ubicación:', error)
  }
}

async function marcarSegundaUbicacion() {
  try {
    window.alert( 'iniciando segundo intento' )
    const pos = await Geolocation.getCurrentPosition()
    pos2.value = {
      latitude: pos.coords.latitude,
      longitude: pos.coords.longitude
    }
    distancia.value = null
  } catch (error) {
    window.alert( error )
    console.error('Error obteniendo segunda ubicación:', error)
  }
}

function calcularDistancia() {
  window.alert( 'calculo' )
  if (pos1.value && pos2.value) {
    distancia.value = haversine(
      pos1.value.latitude,
      pos1.value.longitude,
      pos2.value.latitude,
      pos2.value.longitude
    )
  }
}


import { Device } from '@capacitor/device'

const deviceId = ref(null)
const error = ref(null)

async function getDeviceId() {
  try {
    const info = await Device.getId()
    deviceId.value = info.identifier
  } catch (err) {
    error.value = err.message || 'No se pudo obtener el Device ID'
    console.error(err)
  }
}

</script>
